export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PopupHeader.vue?vue&type=template&id=1cc739d4&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/viewer/components/PopupHeader.vue?vue&type=template&id=1cc739d4&scoped=true&
// module id = 305
// module chunks = 0